import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Marketing.css';

function MarketingLayout() {
  const { user } = useAuth();
  const logoUrl = `${process.env.PUBLIC_URL || ''}/branding/racontera-logo.png`;

  return (
    <div className="marketing">
      <header className="marketing-header">
        <div className="marketing-header-inner">
          <Link to="/" className="marketing-logo-link" title="Racontera home">
            <img src={logoUrl} alt="Racontera" className="marketing-logo" />
          </Link>
          <nav className="marketing-nav" aria-label="Main">
            <Link to="/blog" className="marketing-nav-link">
              Blog
            </Link>
            <a href="/#beta" className="marketing-nav-link">
              Beta
            </a>
            {user ? (
              <Link to="/research/reports" className="marketing-nav-cta">
                Open app
              </Link>
            ) : (
              <Link to="/login" className="marketing-nav-cta">
                Log in
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="marketing-main">
        <Outlet />
      </main>

      <footer className="marketing-footer">
        <div className="marketing-footer-inner">
          <div className="marketing-footer-links">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/login">Log in</Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Racontera</p>
        </div>
      </footer>
    </div>
  );
}

export default MarketingLayout;
